/** Catalog wallet UI — only the superadmin account owner, not tenant project admins. */
export function isCatalogOwnerBillingRole(role) {
  return role === 'superadmin';
}
